import { jsx as _jsx } from "react/jsx-runtime";
import stylex from '@stylexjs/stylex';
import { commonStyles } from '../../helpers/commonStyles';
export const PreventAutoFocus = () => {
    // This is a hack to prevent the first focusable element from being focused
    // when the side sheet is opened.
    return _jsx("button", { type: 'button', ...stylex.props(commonStyles.outOfScreen) });
};
